import React from 'react';
import TableTop from "./TableTop";
import leftarrow from '../../../icons/leftarrow.png';
import rightarrow from '../../../icons/rightarrow.png';

const Table16 = () => (
    <>
        <TableTop />
        <div className="table-responsive tableFixHead">
            <table className="table table-bordered table-style">
                <thead>
                <tr>
                    <th rowSpan={3} scope="col">№</th>
                    <th rowSpan={3} scope="col">Havza boshqarmalari nomi</th>
                    <th rowSpan={3} scope="col">Respublika va viloyatlar nomi</th>
                    <th colSpan={5} scope="col">Sug’orishga sariflanayotgan miqdori, mln.m3.</th>
                    <th colSpan={6} scope="col">O’rtacha kunlik suv sarfi, m3/sek</th>
                </tr>
                <tr>
                    <th colSpan={2} scope="col">Limitlar</th>
                    <th rowSpan={2} scope="col">Amalda</th>
                    <th rowSpan={2} scope="col">Jami limitlarga nisbatan %</th>
                    <th rowSpan={2} scope="col">1 apreldan shu kungacham limitlar nisbati %</th>
                    <th colSpan={3} scope="col">Limitlar</th>
                    <th colSpan={3} scope="col">Limitlar</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>1</th>
                    <th>Amudaryo daryosidam</th>
                    <td></td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>2</th>
                    <th>Qoraqalpog’iston SXB</th>
                    <td>      Qoraqalpog’iston</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>3</th>
                    <th>      Chapqirg’oq-Amudaryo ITHB</th>
                    <td>Xorazm</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>4</th>
                    <th>      Amu-Qashqadaryo ITHB</th>
                    <td>Qashqadaryo </td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>5</th>
                    <th>      ABMKdan</th>
                    <td> </td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>6</th>
                    <th>      Amu-Buxoro ITHB</th>
                    <td> Buxoro</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>7</th>
                    <th>      Quyi-Zarafshon ITHB</th>
                    <td> Navoiy</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>8</th>
                    <th>       Zarafshon daryosidan</th>
                    <td> </td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>9</th>
                    <th>      Zarafshon ITHB</th>
                    <td> Samarqand</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>10</th>
                    <th>      Amu-Qashqadaryo ITHB</th>
                    <td> Qashqadaryo</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>11</th>
                    <th>      Quyi-Zarafshon ITHB</th>
                    <td> Navoiy</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>12</th>
                    <th>      Sirdaryo-Zarafshon ITHB</th>
                    <td> Jizzax</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>13</th>
                    <th>      Amu-Surxon ITHB</th>
                    <td>Surxondaryo</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>14</th>
                    <th>      Norin-Qoradaryo ITHB</th>
                    <td>Andijon</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>15</th>
                    <th>Norin-Sirdaryo ITHB</th>
                    <td>Namangan</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>16</th>
                    <th>Sirdaryo-So’x ITHB</th>
                    <td>Farg’ona</td>
                    <td>2.9</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                </tbody>
            </table>
        </div>
        <ul className="table-pagination">
            <li>Rows per page: 10</li>
            <li>1-10 of 276</li>
            <li><button><img src={leftarrow} alt="404"/></button></li>
            <li><button><img src={rightarrow} alt="404"/></button></li>
        </ul>
    </>
);
export default Table16;